import React, { useState, useEffect, useRef } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import { selectVarient, setQuantity } from "../../store/slices/selectVarient";
import { connect, useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import {
  fetchAllCartsAsync,
  addToCartsAsync,
  removeFromCartsAsync,
  selectAllCarts,
  selectAllPreorders,
  addToPreorderCartsAsync,
  fetchAllPreorderCartsAsync,
} from "../../features/cartPage/cartPageSlice";
import AddTaskOutlinedIcon from "@mui/icons-material/AddTaskOutlined";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { findPDPqty } from "../../data";
import { useNavigate } from "react-router";
import {
  calculateDealerPrice,
  calculateUpdatedDiscountPercentage,
  formatWithCommasWithDecimal,
} from "../../utils/utils";
import { FormattedNumber } from "../../utils/numberAnimation";
import {
  selectIsOverlayVisible,
  toggleOverlay,
} from "../../store/slices/headerSlice";
import { trackEvent } from "../../analytics/gtag";
import { EVENTS } from "../../analytics/events";

function ProductPurchase({
  currentProduct,
  qtys,
  cartVal,
  setCartVal,
  availableSizes,
  availableColors,
  selectedSize,
  selectColor,
  toggleOverlay,
  isOverlayVisible,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const selectedVariant = useSelector(
    (state) => state.productDetail.selectedVariant
  );
  const userDetail = useSelector(selectUser);
  const cart = useSelector(selectAllCarts);
  const preOrder = useSelector(selectAllPreorders);
  const quantity = findPDPqty(selectedVariant?.SKU_ID, qtys && qtys) || 0;

  useEffect(() => {
    if (findPDPqty(selectedVariant?.SKU_ID, qtys && qtys)) {
      dispatch(
        setQuantity(findPDPqty(selectedVariant?.SKU_ID, qtys && qtys) || 0)
      );
    }
  }, [dispatch, currentProduct]);

  const [shippingOpen, setShippingOpen] = useState(false);
  const [requestSubmitted, setRequestSubmitted] = useState(false);
  const [isCartValueZero, setIsCartValueZero] = useState(false);

  const handleInputChange = (e) => {
    // Ensure the entered value is a number
    let inputValue = parseInt(e.target.value);
    if (currentProduct && currentProduct[0]?.Manufacturer === "ESI") {
      setCartVal(parseInt(inputValue && inputValue) || 0);
    } else {
      const newQuantity = Math.min(inputValue || 0, quantity || 1);
      setCartVal(newQuantity);
    }
  };

  const handleInputBlur = () => {
    // If the user enters a quantity beyond the product quantity, adjust it
    if (currentProduct && currentProduct[0]?.Manufacturer === "ESI") {
      const updateqty = parseInt(
        cartVal % parseInt(currentProduct && currentProduct[0]?.Bundle)
      );

      setCartVal(String(cartVal - updateqty));
    } else {
      if (cartVal < quantity) {
        const updateqty = parseInt(
          cartVal % parseInt(currentProduct && currentProduct[0]?.Bundle)
        );

        setCartVal(String(cartVal - updateqty));
      } else {
        const updateqty = parseInt(
          quantity % parseInt(currentProduct && currentProduct[0]?.Bundle)
        );

        setCartVal(String(quantity - updateqty));
      }
    }
  };

  const handleCurrentPrice = () => {
    const originalPrice = calculateDealerPrice(
      parseInt(selectedVariant?.MRP_price),
      parseInt(selectedVariant?.NDP_Price),
      currentProduct && currentProduct[0] && currentProduct[0]?.GST
    );

    const discountedPrice = originalPrice;
    const finalPrice = discountedPrice * cartVal;
    return finalPrice;
  };
  const handleRequestMore = () => {
    setRequestSubmitted(true);

    setTimeout(() => {
      setRequestSubmitted(false);
    }, 2000); // Remove message after 3 seconds (3000 milliseconds)
  };

  function increaseCarts(cartVal) {
    // should increase multiple of cartVal * currentProduct[0].Bundle
    const bundleSize = parseInt(currentProduct && currentProduct[0]?.Bundle);
    if (currentProduct && currentProduct[0].Manufacturer === "ESI") {
      setCartVal(parseInt(cartVal) + parseInt(bundleSize));
    } else {
      const maxQty = findPDPqty(selectedVariant?.SKU_ID, qtys && qtys);
      if (cartVal + bundleSize <= maxQty) {
        setCartVal(cartVal + bundleSize);
      }
    }
  }
  function decreaseCarts() {
    // should decrease multiple of cartVal * currentProduct[0].Bundle
    const bundleSize = parseInt(currentProduct && currentProduct[0]?.Bundle);
    if (cartVal >= bundleSize) {
      setCartVal(cartVal - bundleSize);
    } else if (cartVal > 1) {
      // If current quantity is not a multiple of bundleSize but > 1, decrease to nearest multiple
      setCartVal(Math.max(1, Math.floor(cartVal / bundleSize) * bundleSize));
    }
  }

  useEffect(() => {
    if (cartVal > 0) {
      setIsCartValueZero(false);
    }
  }, [cartVal]);

  // TO ADD PRODUCT INTO CART
  const addToCart = () => {
    if (
      availableSizes &&
      availableSizes[0] !== null &&
      availableColors &&
      availableColors[0] !== null
    ) {
      if (selectedSize && selectColor) {
        handleOpen();
        let cartData = {
          userID: userDetail?.UserID,
          SKU: selectedVariant?.SKU_ID,
          buyQty:
            cartVal === 0
              ? currentProduct && currentProduct[0]?.Bundle
              : cartVal,
        };
        if (Object.keys(userDetail).length > 0 && cartVal >= 1) {
          dispatch(addToCartsAsync(cartData)).then(() => {
            // analytics
            trackEvent({
              action: EVENTS.ADD_TO_CART,
              category: "Cart",
              label: `User Added Product-> SKU: ${selectedVariant?.SKU_ID}`,
              value: userDetail?.PhoneNumber,
            });
            dispatch(fetchAllCartsAsync(userDetail.UserID)).then(() => {
              handleClose();
            });
          });
        } else if (Object.keys(userDetail).length > 0 && cartVal === 0) {
          setIsCartValueZero(true);
          handleClose();
        } else {
          handleClose();
        }
      } else {
        return;
      }
    } else if (
      availableSizes &&
      availableSizes[0] !== null &&
      availableColors[0] === null
    ) {
      if (selectedSize !== null) {
        handleOpen();
        let cartData = {
          userID: userDetail?.UserID,
          SKU: selectedVariant?.SKU_ID,
          buyQty:
            cartVal === 0
              ? currentProduct && currentProduct[0]?.Bundle
              : cartVal,
        };
        if (Object.keys(userDetail).length > 0 && cartVal >= 1) {
          dispatch(addToCartsAsync(cartData)).then(() => {
            // analytics
            trackEvent({
              action: EVENTS.ADD_TO_CART,
              category: "Cart",
              label: `User Added Product-> SKU: ${selectedVariant?.SKU_ID}`,
              value: userDetail?.PhoneNumber,
            });
            dispatch(fetchAllCartsAsync(userDetail.UserID)).then(() => {
              handleClose();
            });
          });
        } else if (Object.keys(userDetail).length > 0 && cartVal === 0) {
          setIsCartValueZero(true);
          handleClose();
        } else {
          handleClose();
        }
      }
    } else if (
      availableSizes &&
      availableSizes[0] === null &&
      availableColors &&
      availableColors[0] !== null
    ) {
      if (selectColor) {
        handleOpen();
        let cartData = {
          userID: userDetail?.UserID,
          SKU: selectedVariant?.SKU_ID,
          buyQty:
            cartVal === 0
              ? currentProduct && currentProduct[0]?.Bundle
              : cartVal,
        };
        if (Object.keys(userDetail).length > 0 && cartVal >= 1) {
          dispatch(addToCartsAsync(cartData)).then(() => {
            // analytics
            trackEvent({
              action: EVENTS.ADD_TO_CART,
              category: "Cart",
              label: `User Added Product-> SKU: ${selectedVariant?.SKU_ID}`,
              value: userDetail?.PhoneNumber,
            });
            dispatch(fetchAllCartsAsync(userDetail.UserID)).then(() => {
              handleClose();
            });
          });
        } else if (Object.keys(userDetail).length > 0 && cartVal === 0) {
          setIsCartValueZero(true);
          handleClose();
        } else {
          handleClose();
        }
      }
    } else {
      return;
    }
  };

  const buyNowHandle = () => {
    if (isInCart()) {
      navigate("/carts");
      // analytics
      trackEvent({
        action: EVENTS.CART_STEP,
        category: "Cart Step",
        label: `User Enter Cart Step`,
        value: userDetail?.PhoneNumber,
      });
    } else {
      if (
        availableSizes &&
        availableSizes[0] !== null &&
        availableColors &&
        availableColors[0] !== null
      ) {
        if (selectedSize && selectColor) {
          handleOpen();
          let cartData = {
            userID: userDetail?.UserID,
            SKU: selectedVariant?.SKU_ID,
            buyQty:
              cartVal === 0
                ? currentProduct && currentProduct[0]?.Bundle
                : cartVal,
          };
          if (Object.keys(userDetail).length > 0 && cartVal >= 1) {
            dispatch(addToCartsAsync(cartData)).then(() => {
              // analytics
              trackEvent({
                action: EVENTS.ADD_TO_CART,
                category: "Cart",
                label: `User Added Product-> SKU: ${selectedVariant?.SKU_ID}`,
                value: userDetail?.PhoneNumber,
              });
              dispatch(fetchAllCartsAsync(userDetail.UserID)).then(() => {
                handleClose();
                navigate("/carts");
                // analytics
                trackEvent({
                  action: EVENTS.CART_STEP,
                  category: "Cart Step",
                  label: `User Enter Cart Step`,
                  value: userDetail?.PhoneNumber,
                });
              });
            });
          } else if (Object.keys(userDetail).length > 0 && cartVal === 0) {
            setIsCartValueZero(true);
            handleClose();
          } else {
            handleClose();
          }
        } else {
          return;
        }
      } else if (
        availableSizes &&
        availableSizes[0] !== null &&
        availableColors[0] === null
      ) {
        if (selectedSize !== null) {
          handleOpen();
          let cartData = {
            userID: userDetail?.UserID,
            SKU: selectedVariant?.SKU_ID,
            buyQty:
              cartVal === 0
                ? currentProduct && currentProduct[0]?.Bundle
                : cartVal,
          };
          if (Object.keys(userDetail).length > 0 && cartVal >= 1) {
            dispatch(addToCartsAsync(cartData)).then(() => {
              // analytics
              trackEvent({
                action: EVENTS.ADD_TO_CART,
                category: "Cart",
                label: `User Added Product-> SKU: ${selectedVariant?.SKU_ID}`,
                value: userDetail?.PhoneNumber,
              });
              dispatch(fetchAllCartsAsync(userDetail.UserID)).then(() => {
                handleClose();
                navigate("/carts");
                // analytics
                trackEvent({
                  action: EVENTS.CART_STEP,
                  category: "Cart Step",
                  label: `User Enter Cart Step`,
                  value: userDetail?.PhoneNumber,
                });
              });
            });
          } else if (Object.keys(userDetail).length > 0 && cartVal === 0) {
            setIsCartValueZero(true);
            handleClose();
          } else {
            handleClose();
          }
        }
      } else if (
        availableSizes &&
        availableSizes[0] === null &&
        availableColors &&
        availableColors[0] !== null
      ) {
        if (selectColor) {
          handleOpen();
          let cartData = {
            userID: userDetail?.UserID,
            SKU: selectedVariant?.SKU_ID,
            buyQty:
              cartVal === 0
                ? currentProduct && currentProduct[0]?.Bundle
                : cartVal,
          };
          if (Object.keys(userDetail).length > 0 && cartVal >= 1) {
            dispatch(addToCartsAsync(cartData)).then(() => {
              // analytics
              trackEvent({
                action: EVENTS.ADD_TO_CART,
                category: "Cart",
                label: `User Added Product-> SKU: ${selectedVariant?.SKU_ID}`,
                value: userDetail?.PhoneNumber,
              });
              dispatch(fetchAllCartsAsync(userDetail.UserID)).then(() => {
                handleClose();
                navigate("/carts");
                // analytics
                trackEvent({
                  action: EVENTS.CART_STEP,
                  category: "Cart Step",
                  label: `User Enter Cart Step`,
                  value: userDetail?.PhoneNumber,
                });
              });
            });
          } else if (Object.keys(userDetail).length > 0 && cartVal === 0) {
            setIsCartValueZero(true);
            handleClose();
          } else {
            handleClose();
          }
        }
      } else {
        return;
      }
    }
  };

  const removeFromCart = () => {
    handleOpen();
    let cartData = {
      userID: userDetail?.UserID,
      SKU: selectedVariant?.SKU_ID,
    };
    dispatch(removeFromCartsAsync(cartData)).then(() => {
      // analytics
      trackEvent({
        action: EVENTS.REMOVE_FROM_CART,
        category: "Cart",
        label: `User Remove Product-> SKU: ${selectedVariant?.SKU_ID}`,
        value: userDetail?.PhoneNumber,
      });
      dispatch(fetchAllCartsAsync(userDetail.UserID)).then(() => {
        handleClose();
      });
    });
  };

  // Function to check if a product is in the cart
  const isInCart = () => {
    return (
      Array.isArray(cart) &&
      cart?.some((item) => item?.skuDetails?.SKU_ID === selectedVariant?.SKU_ID)
    );
  };

  // Function to check if a product is in the prebook
  const isInPreBook = () => {
    return (
      Array.isArray(preOrder) &&
      preOrder?.some(
        (item) => parseInt(item?.SKU_ID) === parseInt(selectedVariant?.SKU_ID)
      )
    );
  };

  const addToPreBook = () => {
    if (
      availableSizes &&
      availableSizes[0] !== null &&
      availableColors &&
      availableColors[0] !== null
    ) {
      if (selectedSize && selectColor) {
        handleOpen();
        let preOrderData = {
          UserID: userDetail?.UserID,
          SKU_ID: selectedVariant?.SKU_ID,
          quantity:
            cartVal === 0
              ? currentProduct && currentProduct[0]?.Bundle
              : cartVal,
        };
        if (Object.keys(userDetail).length > 0 && cartVal >= 1) {
          dispatch(addToPreorderCartsAsync(preOrderData)).then(() => {
            dispatch(fetchAllPreorderCartsAsync(userDetail.UserID)).then(() => {
              handleClose();
            });
          });
        } else if (Object.keys(userDetail).length > 0 && cartVal === 0) {
          setIsCartValueZero(true);
          handleClose();
        } else {
          handleClose();
        }
      } else {
        return;
      }
    } else if (
      availableSizes &&
      availableSizes[0] !== null &&
      availableColors[0] === null
    ) {
      if (selectedSize !== null) {
        handleOpen();
        let preOrderData = {
          UserID: userDetail?.UserID,
          SKU_ID: selectedVariant?.SKU_ID,
          quantity:
            cartVal === 0
              ? currentProduct && currentProduct[0]?.Bundle
              : cartVal,
        };
        if (Object.keys(userDetail).length > 0 && cartVal >= 1) {
          dispatch(addToPreorderCartsAsync(preOrderData)).then(() => {
            dispatch(fetchAllPreorderCartsAsync(userDetail.UserID)).then(() => {
              handleClose();
            });
          });
        } else if (Object.keys(userDetail).length > 0 && cartVal === 0) {
          setIsCartValueZero(true);
          handleClose();
        } else {
          handleClose();
        }
      }
    } else if (
      availableSizes &&
      availableSizes[0] === null &&
      availableColors &&
      availableColors[0] !== null
    ) {
      if (selectColor) {
        handleOpen();
        let preOrderData = {
          UserID: userDetail?.UserID,
          SKU_ID: selectedVariant?.SKU_ID,
          quantity:
            cartVal === 0
              ? currentProduct && currentProduct[0]?.Bundle
              : cartVal,
        };
        if (Object.keys(userDetail).length > 0 && cartVal >= 1) {
          dispatch(addToPreorderCartsAsync(preOrderData)).then(() => {
            dispatch(fetchAllPreorderCartsAsync(userDetail.UserID)).then(() => {
              handleClose();
            });
          });
        } else if (Object.keys(userDetail).length > 0 && cartVal === 0) {
          setIsCartValueZero(true);
          handleClose();
        } else {
          handleClose();
        }
      }
    } else {
      return;
    }
  };

  const calculateGST = (price, gstPercentage) => {
    // Ensure both price and gstPercentage are valid numbers
    if (
      typeof price !== "number" ||
      isNaN(price) ||
      typeof gstPercentage !== "number" ||
      isNaN(gstPercentage)
    ) {
      throw new Error(
        "Invalid input. Price and GST percentage must be numbers."
      );
    }

    // Calculate GST amount
    const gstAmount = (price * gstPercentage) / 100;
    return gstAmount;
  };

  return (
    <div className="product-purchase">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open} // Show backdrop when either open or filtering state is true
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="product-pricing-details">
        <div className="product-pricing-div">
          <p>MRP</p>
          <hr />
          <span>
            ₹
            {formatWithCommasWithDecimal(
              selectedVariant && parseInt(selectedVariant?.MRP_price)
            )}
          </span>
        </div>
        <div
          className="product-pricing-div"
          style={{ display: "flex", alignItems: "center" }}
        >
          <p>Sale Price</p>
          <hr />
          <span>
            ₹
            {formatWithCommasWithDecimal(
              calculateDealerPrice(
                parseInt(selectedVariant?.MRP_price),
                parseInt(selectedVariant?.NDP_Price),
                currentProduct && currentProduct[0]?.GST
              )
            )}
          </span>
        </div>
        {calculateUpdatedDiscountPercentage(
          selectedVariant && selectedVariant?.MRP_price,
          parseInt(selectedVariant?.NDP_Price),
          currentProduct && currentProduct[0]?.GST
        ) >= 1 && (
          <div className="product-pricing-div">
            <p>OFF</p>
            <hr />
            <span>
              {calculateUpdatedDiscountPercentage(
                selectedVariant && selectedVariant?.MRP_price,
                parseInt(selectedVariant?.NDP_Price),
                currentProduct && currentProduct[0]?.GST
              )}
              %
            </span>
          </div>
        )}
        <div className="product-pricing-div">
          <p>
            GST{" "}
            <b style={{ fontWeight: "500", fontSize: "0.75vw" }}>(per item)</b>
          </p>
          <hr />
          <span>
            ₹
            {calculateGST(
              parseInt(
                selectedVariant?.NDP_Price && selectedVariant?.NDP_Price
              ),
              parseInt(
                currentProduct &&
                  currentProduct[0]?.GST &&
                  currentProduct[0]?.GST
              )
            )}{" "}
            <b style={{ fontSize: "0.9vw", fontWeight: "600" }}>
              (
              {parseInt(
                currentProduct &&
                  currentProduct[0]?.GST &&
                  currentProduct[0]?.GST
              )}
              %)
            </b>
          </span>
        </div>
        <div className="product-pricing-div">
          <p>Shipping To</p>
          <hr />
          {Object.keys(userDetail).length > 0 ? (
            <span>
              {userDetail?.location}-{userDetail?.pin_code}
            </span>
          ) : (
            <span>...</span>
          )}
        </div>
        <div className="product-pricing-div-container"></div>
        <div className="product-estimated-date-container">
          <AirplanemodeActiveIcon />
          <span className="estimated-data-span">
            Estimated delivery:{" "}
            {new Date(
              new Date().getTime() + 7 * 24 * 60 * 60 * 1000
            ).toLocaleDateString("en-US", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </span>
        </div>
      </div>
      <div className="products-carts-container">
        <div className="products-carts-instock-container">
          {cartVal ===
          findPDPqty(
            selectedVariant && selectedVariant?.SKU_ID,
            qtys && qtys
          ) ? (
            <div className="max-inventery-count-request">
              <span className="max-inventery-count">
                <div>
                  <sup>*</sup>only{" "}
                  {findPDPqty(
                    selectedVariant && selectedVariant?.SKU_ID,
                    qtys && qtys
                  )}{" "}
                  units in stocks!
                </div>
              </span>
              <div
                className={`request-submitted-success ${
                  requestSubmitted ? "open" : ""
                }`}
              >
                <iframe
                  src="https://giphy.com/embed/QJ4Hm8oJgMJIqFAuVc"
                  width="50"
                  height="50"
                  title="done"
                  frameBorder="0"
                  class="giphy-embed"
                  allowFullScreen
                ></iframe>
                <span>Your request has been submitted successfully!</span>
              </div>
              <span
                className="product-request-more"
                onClick={handleRequestMore}
              >
                Request more
              </span>
            </div>
          ) : (
            <div className="product-inStock">
              <CheckBoxOutlinedIcon />
              <span>In Stock</span>
            </div>
          )}
        </div>
        <div className="products-carts-quantity-price-container">
          <div className="product-carts-counter-div">
            <p>Quantity:</p>
            <div className="product-counter-invertory">
              <div className="product-counter">
                <KeyboardArrowDownIcon
                  style={{
                    background:
                      cartVal <
                      parseInt(currentProduct && currentProduct[0]?.Bundle)
                        ? "rgb(165, 157, 159)"
                        : "var(--color-blue)",
                    borderRadius: "50px",
                    width: "25px",
                    height: "25px",
                    cursor: "pointer",
                  }}
                  onClick={() => decreaseCarts(cartVal)}
                />
                <input
                  type="text"
                  onKeyPress={(e) => {
                    if (!/[0-9\b]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  value={cartVal}
                  onChange={handleInputChange}
                  onBlur={handleInputBlur}
                  style={{ border: isCartValueZero ? "1px solid red" : "" }}
                />
                <KeyboardArrowUpIcon
                  style={{
                    background:
                      cartVal ===
                        findPDPqty(selectedVariant?.SKU_ID, qtys && qtys) &&
                      currentProduct &&
                      currentProduct[0]?.Manufacturer !== "ESI"
                        ? "rgb(165, 157, 159)"
                        : "var(--color-blue)",
                    borderRadius: "50px",
                    width: "25px",
                    height: "25px",
                    cursor: "pointer",
                  }}
                  onClick={() => increaseCarts(cartVal)}
                />
              </div>
            </div>
            {(cartVal <= 0 ||
              (availableSizes && availableSizes[0] !== null && !selectedSize) ||
              (availableColors &&
                availableColors[0] !== null &&
                !selectColor)) && (
              <div className="pdp-show-message-for-variant-part">
                <sub style={{ marginTop: "-6px" }}>★</sub>Please select{" "}
                {availableSizes &&
                  availableSizes[0] !== null &&
                  !selectedSize && <span>&nbsp;size</span>}{" "}
                {availableColors &&
                  availableColors[0] !== null &&
                  !selectColor && <span>, color</span>}{" "}
                {cartVal <= 0 && <span>, quantity</span>}
              </div>
            )}
          </div>
          <div className="products-totals-price">
            Total:&nbsp; <FormattedNumber value={handleCurrentPrice()} />
          </div>
        </div>
        <div className="products-carts-btn-container">
          {currentProduct && currentProduct[0]?.Manufacturer === "ESI" ? (
            <div
              className="desktop-prebook-btn-container"
              style={{ height: "40px" }}
            >
              {isInPreBook() ? (
                <span className="desktop-prebook-remove-btn">
                  <AddTaskOutlinedIcon />
                  Pre-Booked
                </span>
              ) : (
                <span
                  className="desktop-prebook-book-btn"
                  onClick={() => addToPreBook()}
                >
                  Pre-Book - At no advance cost
                </span>
              )}
            </div>
          ) : (
            <>
              <span
                className="add-cart"
                onClick={() => {
                  if (userDetail && userDetail?.UserID) {
                    if (isInCart()) {
                      removeFromCart();
                    } else {
                      addToCart();
                    }
                  } else {
                    toggleOverlay();
                  }
                }}
              >
                {isInCart() ? <span>Added</span> : <span>Add to Cart</span>}
              </span>
              <span
                className="buy-now-btn"
                onClick={() => {
                  if (userDetail && userDetail?.UserID) {
                    buyNowHandle();
                  } else {
                    toggleOverlay();
                  }
                }}
              >
                <span>Buy Now</span>
              </span>
            </>
          )}
        </div>
      </div>
     
    </div>
  );
}

const mapStateToProps = (state) => ({
  isOverlayVisible: selectIsOverlayVisible(state),
});
const mapDispatchToProps = {
  toggleOverlay,
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductPurchase);
